import getStore from './store';
import { OWAConnectedAccount, AccountProviderType } from './schema/OWAConnectedAccount';
import { assertNever } from 'owa-assert';
import { isConnectedAccount } from './utils/isConnectedAccount';

export function getOWAConnectedAccounts(): OWAConnectedAccount[] {
    return [...getStore().accountsMap.values()];
}

export function getOWAConnectedAccount(primarySmtpAddress: string): OWAConnectedAccount {
    return getStore().accountsMap.get(primarySmtpAddress);
}

/**
 * Gets the AccountProviderType for an account.
 * Returns the AccountProviderType if the account is a connected account, otherwise returns null
 * @param primarySmtpAddress primarySmtp address
 */
export function getOWAAccountProvider(primarySmtpAddress: string): AccountProviderType | null {
    return isConnectedAccount(primarySmtpAddress)
        ? getOWAConnectedAccount(primarySmtpAddress).accountProviderType
        : null;
}

export function getOWAConnectedAccountTokenString(account: OWAConnectedAccount): string {
    if (account.accountProviderType == 'Outlook') {
        return `MSAuth1.0 usertoken="${account.token}", type="MSACT"`;
    } else if (account.accountProviderType == 'Google') {
        return `Bearer ${account.token}`;
    } else {
        return assertNever(account.accountProviderType);
    }
}

function getPropFromOWAConnectedAccount<K extends keyof OWAConnectedAccount>(
    propertyName: K,
    defaultValue: OWAConnectedAccount[K]
) {
    return function(primarySmtpAddress: string) {
        const connectedAccount = getOWAConnectedAccount(primarySmtpAddress);
        return connectedAccount ? connectedAccount[propertyName] : defaultValue;
    };
}

export const getOWAConnectedAccountUniqueId = getPropFromOWAConnectedAccount(
    'accountUniqueId',
    '0'
);
export const getOWAConnectedAccountStatus = getPropFromOWAConnectedAccount('isAccountValid', true);
const getOWAConnectedAccountProviderType = getPropFromOWAConnectedAccount(
    'accountProviderType',
    null
);
export const isOutlookConsumerAccount = (primarySmtpAddress: string) =>
    getOWAConnectedAccountProviderType(primarySmtpAddress) == 'Outlook';
